import { useState } from "react";
import Joi from "joi-browser";

export default usePayloadMappingForm;
export { payloadMappingSchema };

const payloadMappingSchema = {
  sourceField: Joi.string().required().label("Source Field"),
  targetField: Joi.string().required().label("Target Field"),
  targetType: Joi.string().required().label("Target Type"),
  isRequired: Joi.boolean().required().label("Required Field"),
  defaultValue: Joi.string().allow(null, "").label("Fallback Value"),
};

function usePayloadMappingForm(payloadMapping) {
  const [formState, setFormState] = useState({
    sourceField: payloadMapping.sourceField,
    targetField: payloadMapping.targetField,
    targetType: payloadMapping.targetType,
    isRequired: payloadMapping.isRequired,
    defaultValue: payloadMapping.defaultValue,
  });

  const [errors, setErrors] = useState({});

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(payloadMappingSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });
    setErrors(fieldErrors);
    return false;
  };

  return { formState, errors, updateFormState, validate };
}
